'use client'

import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

interface LoginRequiredModalProps {
  isOpen: boolean
  onClose: () => void
}

const LoginRequiredModal = ({ isOpen, onClose }: LoginRequiredModalProps) => {
  const router = useRouter()

  const t = useTranslations('UserAccount.login')

  useEffect(() => {
    if (isOpen) {
      // Empêcher le scroll du body quand la modal est ouverte
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    // Nettoyer au démontage
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleLoginRedirect = () => {
    router.push('/mon-compte')
    onClose()
  }



  

  const modalContent = (
    <div 
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm" 
      style={{ zIndex: 999999 }}
      onClick={onClose}
    >
      <div 
        className="mx-4 max-w-md rounded-lg bg-white p-6 shadow-xl" 
        style={{ zIndex: 1000000 }}
        onClick={(e) => e.stopPropagation()}>
        <div className="mb-4 text-center">
          <h2 className="text-xl font-bold text-gray-900">
            Connexion requise
          </h2>
        </div>
        
        <div className="mb-6 text-center">
          <p className="text-gray-600">
            {t('loginMandatoryForFavorites')}
          </p>
        </div>
   
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={handleLoginRedirect}
            className="rounded-lg bg-green px-6 py-2 text-white transition hover:bg-green/90"
          >
            Se connecter
          </button>
          <button
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-6 py-2 text-gray-700 transition hover:bg-gray-50"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  )

  // Utiliser createPortal pour rendre la modal au niveau du body
  return typeof window !== 'undefined' 
    ? createPortal(modalContent, document.body)
    : null
}

export default LoginRequiredModal